import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import useSectorDiversification from '../../../../stores/profile/modules/use-sector-diversification';
import { get as gc } from '../../../../utils/GlobalCssProxy';

const SectorDiversification = ({
  ticker,
  isFundNonProp = false,
  setRenderSectorDiversification
}) => {
  const { asOfDate, sectors, renderSectorDiversification } = useSectorDiversification();
  const indexToSlice = Math.ceil(sectors.length / 2);
  const secondTableData = sectors.slice(indexToSlice);
  const hideSecondTable = secondTableData.length === 0;

  setRenderSectorDiversification && setRenderSectorDiversification(renderSectorDiversification);
  return (
    <CardModule
      data-analytics-componenttype="twothirds-width-component"
      data-analytics-id="TTW_SectorDiversification"
      data-analytics-section="component"
    >
      <CardModule.Header>
        Sector Diversification
        <CardModule.AsOfDate>{format.date(asOfDate)}</CardModule.AsOfDate>
      </CardModule.Header>
      <CardModule.Body>
        {/* Hiding first two tables so screen readers read from the table that has all the data*/}
        <Container>
          <Row>
            <Col sm={12} md={hideSecondTable ? 12 : 6} aria-hidden={true}>
              <TableBasic flush>
                <thead>
                  <tr>
                    <th className={gc('text-left')}>Sector</th>
                    <th className={gc('text-right', 'text-nowrap')}>% of Net Assets</th>
                  </tr>
                </thead>
                <tbody>
                  {sectors.map((item, index) => {
                    const isOverflow = index >= indexToSlice;
                    return (
                      <tr
                        data-key={`${item.sector || ''}-${index}`}
                        key={`${item.sector || ''}-${index}`}
                        className={isOverflow ? gc('d-md-none') : ''}
                      >
                        <th scope="row" className={gc('text-left')}>
                          {format.text(item.sector)}
                        </th>
                        <td className={gc('text-right', 'font-weight-bold')}>
                          {item.sectorPercent ? format.percent(item.sectorPercent) : '--'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </TableBasic>
            </Col>
            {!hideSecondTable ? (
              <Col md={6} className={gc('d-none', 'd-sm-none', 'd-md-block')} aria-hidden={true}>
                <TableBasic flush>
                  <thead>
                    <tr>
                      <th className={gc('text-left')}>Sector</th>
                      <th className={gc('text-right', 'text-nowrap')}>% of Net Assets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {secondTableData.map((item, index) => (
                      <tr
                        data-key={`${item.sector || ''}-${index}`}
                        key={`${item.sector || ''}-${index}`}
                      >
                        <th scope="row" className={gc('text-left')}>
                          {format.text(item.sector)}
                        </th>
                        <td className={gc('text-right', 'font-weight-bold')}>
                          {item.sectorPercent ? format.percent(item.sectorPercent) : '--'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </TableBasic>
              </Col>
            ) : undefined}
            <Col className={gc('sr-only', 'p-0')}>
              <TableBasic>
                <caption>Sector diversification for {ticker}</caption>
                <thead>
                  <tr>
                    <th>Sector</th>
                    <th>% of Net Assets</th>
                  </tr>
                </thead>
                <tbody>
                  {sectors.map((item, index) => (
                    <tr
                      data-key={`${item.sector || ''}-${index}`}
                      key={`${item.sector || ''}-${index}`}
                    >
                      <th scope="row" className={gc('text-left')}>
                        {format.text(item.sector)}
                      </th>
                      <td>{format.number(item.sectorPercent)}</td>
                    </tr>
                  ))}
                </tbody>
              </TableBasic>
            </Col>
          </Row>
        </Container>
      </CardModule.Body>
      {!isFundNonProp && (
        <CardModule.Footer className={gc('text-right')}>
          <ButtonDisclosures module={'sector-diversification'} />
        </CardModule.Footer>
      )}
    </CardModule>
  );
};

SectorDiversification.defaultProps = {
  ticker: null
};

SectorDiversification.propTypes = {
  isFundNonProp: PropTypes.bool,
  ticker: PropTypes.string,
  setRenderSectorDiversification: PropTypes.func
};

export default SectorDiversification;
